module.exports = __webpack_public_path__ + "mobile/img/board_icon_p.7a43eb2a.svg";